export const animalsValuesCleaner = (value: string): boolean => {
    return value !== AnimalType.Any && value !== AnimalType.None
}

export enum AnimalType {
    Any = 'true',
    None = 'false',
    Other = 'OTHER'
}

export enum ChildGender {
    Unknown = 'UNKNOWN',
    Male = 'MALE',
    Female = 'FEMALE'
}

// Для определения значения 'Есть'
export const emptyChild: Child = {
    name: '',
    birthDate: null,
    gender: null
}

export type Child = {
    name?: string
    birthDate?: string
    gender?: 'MALE' | 'FEMALE' | 'UNKNOWN'
}

export const isChildrenListEmpty = (children: Child[]): boolean => {
    if (!children) return true

    const emptyChildren = children?.filter(({name, gender, birthDate}) => {
        return !((name === '' || name === null)
            && gender === null
            && birthDate === null)
    })

    return !(emptyChildren.length > 0)
}
